// Module
var code = "<div fg-property-field-common=\"{ fieldname: true, displayname: true, tooltip: false }\"></div> <div class=\"properties-validation\"> <div fg-property-field-options></div> </div> ";
// Exports
export default code;